import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { I18nService } from './i18n.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  private navStack: string[] = [];

  constructor(private i18n: I18nService, private router: Router) {
    this.i18n.init();
    this.logNavigationStack();
  }

  private logNavigationStack() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateStack(event.urlAfterRedirects || event.url);
        this.printStack();
      }
    });
  }

  private updateStack(url: string) {
    const last = this.navStack[this.navStack.length - 1];
    const prev = this.navStack[this.navStack.length - 2];
    if (last === url) {
      return;
    }
    if (prev === url) {
      this.navStack.pop();
      return;
    }
    this.navStack.push(url);
    if (this.navStack.length > 30) {
      this.navStack.shift();
    }
  }

  private printStack() {
    const preview = this.navStack.slice().reverse();
    console.log('[NavStack] current -> back', preview);
  }
}
